import { Controller } from "./helpers/controller.js";

class BookingSlot {
    public startTime: Date = new Date();
    public endTime: Date = new Date();
}

export class TrialSlotSelection extends Controller {

    private bookingSlots: BookingSlot[];
    private daySlot: JQuery = $('[name="dateChoice"]');
    private timeSlot: JQuery = $('[name="timeChoice"]');
    private timeSelection: JQuery = $("[data-switch-slot-time]");
    private slotSelectedMessage: JQuery = $("[data-switch-selected-slot]");
    private noSlotMessage: JQuery = $("[data-switch-no-slot]");
    private noGoNext: JQuery = $("[data-switch-form-navigation-step-2]");
    private goNext: JQuery = $("[data-switch-form-navigation-step-2-complete]");
    private noSlotsAvailableMessageAM = "<p class='formInfo''>No slots available at this time, please check PM</p>";
    private noSlotsAvailableMessagePM = "<p class='formInfo''>No slots available please check AM or another date</p>";
    private formChooseSlot = $("[data-switch-slot-pick-form]");

    private bookingSlotsData: JQuery = $('#availableSlotsData');

    constructor(element: HTMLElement) {
        super(element);

        this.bookingSlots = JSON.parse(this.bookingSlotsData.val());

        this.daySlot.on('click', (e) => {
            this.SelectDay();
        });
        
        this.SelectFirstDayAndMeridiem();
    }
    
    SelectFirstDayAndMeridiem = () => {
        // pre-select the first day and am/pm with the first slot
        if (this.bookingSlots.length < 1) {
            return;
        }
        
        // only if a day isn't already selected
        if ($("input[name='dateChoice']:checked").length > 0) {
            return;
        }

        let firstDay = this.bookingSlots[0].startTime.toString().split('T')[0];
        ($("input[name='dateChoice'][value='" + firstDay + "']")[0] as HTMLInputElement).checked = true;
        this.SelectDay();

        if (parseInt(this.bookingSlots[0].startTime.toString().split('T')[1].substring(0,2)) >= 12) {
            $("a[href='#pm']")[0].click();
        }
    }

    SelectDay = () => {
        let selectedDay = $("input[name='dateChoice']:checked").val();
        var selectedDayParts = selectedDay.split('-');
        var selectedDate = new Date(selectedDayParts[0], selectedDayParts[1] - 1, selectedDayParts[2]);
        let selectedDateStartTime = new Date(selectedDate).getTime();
        let selectedDateEndTime = selectedDateStartTime + (60 * 60 * 24 * 1000) - 1;
        let results = this.bookingSlots.filter(d => {
            var bookingSlotTime = new Date(d.startTime).getTime();
            return (selectedDateStartTime < bookingSlotTime && bookingSlotTime < selectedDateEndTime);
        });
        this.RepaintAvailableTimeSlots(results);
    }

    RepaintAvailableTimeSlots = (slots: BookingSlot[]) => {
        let pmSlotsHtml = "";
        let amSlotsHtml = "";
        for (let index = 0; index < slots.length; index++) {
            let slot = slots[index];
            let slotTime = new Date(slot.startTime).toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit" })
            let slotTimeEnd = new Date(slot.endTime).toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit" })
            let slotTimeString = slotTime.replace(':', '-');
            let slotHtml = `
                <label class="radioTimeBlock" for="time${slotTimeString}">
                    <input type="radio" id="time${slotTimeString}" name="timeChoice" value="${slotTime}" data-end-time="${slotTimeEnd}" data-slot-start=${slot.startTime} data-slot-end=${slot.endTime}>
                    <span class="radioTimeLabel">${slotTime}</span>
                </label>
            `;

            if (new Date(slot.startTime).getHours() > 11) {
                pmSlotsHtml += slotHtml;
            } else {
                amSlotsHtml += slotHtml;
            }
        }

        $('#am').html(amSlotsHtml !== "" ? amSlotsHtml : this.noSlotsAvailableMessageAM);
        $('#pm').html(pmSlotsHtml !== "" ? pmSlotsHtml : this.noSlotsAvailableMessagePM);

        $('[name="timeChoice"]').on('click', (e) => {
            this.SelectTimeSlot();
        });

        this.ResetDay();

        this.timeSelection.show();
    }

    SelectTimeSlot = () => {
        let temp = $("input[name='timeChoice']:checked")
        this.formChooseSlot.find('#selectedSlotStartTime').val($("input[name='timeChoice']:checked").data("slot-start"));
        this.formChooseSlot.find('#selectedSlotEndTime').val($("input[name='timeChoice']:checked").data("slot-end"));

        this.noSlotMessage.hide();
        this.RepaintSelectedMessage();
        this.slotSelectedMessage.show();
        this.noGoNext.hide();
        this.goNext.show();

    }

    RepaintSelectedMessage = () =>  {
        let selectedDay = $("input[name='dateChoice']:checked").val();

        var selectedDayParts = selectedDay.split('-');
        var selectedDate = new Date(selectedDayParts[0], selectedDayParts[1] - 1, selectedDayParts[2]);

        let selectedTime = $("input[name='timeChoice']:checked").val();
        let selectedTimeEnd = $("input[name='timeChoice']:checked").data("end-time");
        let message = `${selectedDate.toLocaleDateString("en-GB", { timeZone: "Europe/London", weekday: 'long' })}, ${selectedDate.toLocaleDateString("en-GB", { timeZone: "Europe/London", day: 'numeric' })} ${selectedDate.toLocaleDateString("en-GB", { timeZone: "Europe/London", month: 'short' })}<span>${selectedTime} - ${selectedTimeEnd}</span>`;
        let messageBox = $(".completedItemLarge");
        messageBox.html(message);
    }

    ResetDay = () =>  {
        this.noSlotMessage.show();
        this.slotSelectedMessage.hide();
        this.noGoNext.show();
        this.goNext.hide();
    }
}


